import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class HttpUtilsService {
    private readonly HTTPUTILS_MARKER = 'x-httputils-service';

    private getAuthHeaders(): { [header: string]: string } {
        // const oktaToken = localStorage.getItem('oktaToken');
        // const authToken = localStorage.getItem('authToken');
        // return {
        //     Authorization: oktaToken ? `Bearer ${oktaToken}` : '',
        //     'x-pg-token': authToken ? `Bearer ${authToken}` : ''
        // };
        const token = localStorage.getItem('PgRestToken');
        return {
            Authorization: token ? `Bearer ${token}` : '',
            [this.HTTPUTILS_MARKER]: 'true'
        };
    }

    constructor(private http: HttpClient) { }

    get<T>(endpoint: string): Promise<any> {
        return this.handle(this.http.get<T>(endpoint, { headers: this.getAuthHeaders() }).toPromise(), endpoint, 'GET');
    }

    post<T>(endpoint: string, data: any): Promise<any> {
        return this.handle(this.http.post<T>(endpoint, data, {
            headers: {
                ...this.getAuthHeaders(),
                Prefer: 'return=representation',
                'Content-Type': 'application/json'
            }
        }).toPromise(), endpoint, 'POST');
    }

    patch<T>(endpoint: string, data: any): Promise<any> {
        return this.handle(this.http.patch<T>(endpoint, { data }, { headers: this.getAuthHeaders() }).toPromise(), endpoint, 'PATCH');
    }

    delete<T>(endpoint: string): Promise<any> {
        return this.handle(this.http.delete<T>(endpoint, { headers: this.getAuthHeaders() }).toPromise(), endpoint, 'DELETE');
    }

    private handle<T>(promise: Promise<T>, endpoint: string, method: string): Promise<any> {
        return promise
            .then((result: any) => {
                if (
                    (method === 'GET' && !endpoint.includes('/rpc/')) ||
                    (method === 'POST' && endpoint.includes('/rpc/') && result && (Array.isArray(result) ? result.length > 0 : Object.keys(result).length > 0))
                ) {
                    return this.transformResponse(result);
                }
                return result;
            })
            .catch((error) => {
                console.error(`HTTP ${method} Error on ${endpoint}:`, error);
                throw error;
            });
    }

    private transformResponse(result: any): any {
        if (Array.isArray(result)) {
            return result.map(item => this.flattenItem(item));
        }

        if (result && typeof result === 'object') {
            return this.flattenItem(result);
        }

        return result;
    }

    private flattenItem(item: any): any {
        if (item && typeof item === 'object' && item.data && typeof item.data === 'object') {
            const { data, ...rest } = item;
            return { ...data, ...rest };
        }
        return item;
    }
}
